import { httpClient } from "./client";
import type { PhoneContactApi } from "./interfaces";
import type {
  PhoneVerificationConfirmRequest,
  PhoneVerificationStartRequest,
  PhoneVerificationStartResponse,
  SmsConsentChoiceRequest,
  SmsConsentStatusResponse,
  VerifiedPhoneStatusResponse,
} from "../types/generated";

export const phoneContactApi: PhoneContactApi = {
  getStatus: () =>
    httpClient.get<VerifiedPhoneStatusResponse>("/users/me/phone"),
  remove: () =>
    httpClient.delete<VerifiedPhoneStatusResponse>("/users/me/phone"),
  start: (data: PhoneVerificationStartRequest) =>
    httpClient.post<PhoneVerificationStartResponse>(
      "/users/me/phone/verification", data,
    ),
  confirm: (data: PhoneVerificationConfirmRequest) =>
    httpClient.post<VerifiedPhoneStatusResponse>(
      "/users/me/phone/verification/confirm", data,
    ),
  getSmsConsent: () =>
    httpClient.get<SmsConsentStatusResponse>("/users/me/sms-consent"),
  setSmsConsent: (data: SmsConsentChoiceRequest) =>
    httpClient.put<SmsConsentStatusResponse>("/users/me/sms-consent", data),
};
